import { render, staticRenderFns } from "./BrokerDeposits.vue?vue&type=template&id=4294bf71"
import script from "./BrokerDeposits.vue?vue&type=script&lang=js"
export * from "./BrokerDeposits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports